const PLATFORM: string = 'monavis';
const COUNTRY: string = 'FR';
const LANGUAGE: string = 'fr';
const TIMEZONE: string = 'Europe/Paris';
const MINIMAL_CHAR_LENGTH: number = 10;
const MINIMAL_AGE: number = 18;

const NOTIFICATIONS_DELAY = 500;
const NOTIFICATIONS_DURATION = 10000 + NOTIFICATIONS_DELAY;

const getPlatform = (): string => PLATFORM;
const getCountry = (): string => COUNTRY;
const getLanguage = (): string => LANGUAGE;
const getMinimalCharLength = (): number => MINIMAL_CHAR_LENGTH;

const getBaseUrl = (): string => {
  return `${window.location.protocol}//${window.location.hostname}`;
};

const encryptDate = (date: string | null) => {
  if (!date) {
    return null;
  }

  if (date.length === 10) {
    const yearPart_1 = date.substr(0, 2);
    const yearPart_2 = date.substr(5, 2);
    const label = '**';
    const label_1 = '/';
    return label + label_1 + yearPart_2 + label_1 + yearPart_1 + label;
  }
  return date;
};

const getFirebaseConfig = (isPre: boolean): object => {
  if (isPre) {
    return {
      apiKey: 'AIzaSyB2-CYEMlSC5s-7ThRW-Iw2hOQu0jFV6aw',
      authDomain: 'saz-6b2330c357.firebaseapp.com',
      projectId: 'saz-6b2330c357',
      storageBucket: 'saz-6b2330c357.appspot.com',
      messagingSenderId: '911006561050',
      appId: '1:911006561050:web:8ec0258a2f7337a492f2a3',
      measurementId: 'G-46ENGJB6YJ',
    };
  }
  return {
    apiKey: 'AIzaSyDepgs-sAsXiICFvLhG1V2bgzVehWU7OCs',
    authDomain: 'app-monavislerendgratuit.firebaseapp.com',
    databaseURL: 'https://app-monavislerendgratuit.firebaseio.com',
    projectId: 'app-monavislerendgratuit',
    storageBucket: 'app-monavislerendgratuit.appspot.com',
    messagingSenderId: '367177020782',
    appId: '1:367177020782:web:10bdd2ffe0a07192d53d7f',
    measurementId: 'G-S75C2E220M',
  };
};

export {
  TIMEZONE,
  NOTIFICATIONS_DELAY,
  NOTIFICATIONS_DURATION,
  getMinimalCharLength,
  getPlatform,
  getCountry,
  getLanguage,
  getBaseUrl,
  MINIMAL_AGE,
  getFirebaseConfig,
  encryptDate,
  MINIMAL_CHAR_LENGTH,
};
